export const ACCOUNT_URL = 'https://my.ilpas.it'
export const BILLING_URL = `${ACCOUNT_URL}/billing`

export function isSubscriptionBlocked(error) {
  const response = error && error.response
  return Boolean(response && response.status === 402 && response.data && response.data.code === 'subscription_blocked')
}

/**
 * Giorno di sospensione: il giorno dopo X-Subscription-Valid-Until (YYYY-MM-DD),
 * calcolato in ora locale per evitare lo slittamento UTC di new Date('YYYY-MM-DD').
 */
export function suspensionDate(validUntil) {
  const [year, month, day] = validUntil.split('-').map(Number)
  const date = new Date(year, month - 1, day + 1)
  return date.toLocaleDateString('it-IT', { day: 'numeric', month: 'long', year: 'numeric' })
}
